function showLoader(){
    $(".js-loader").fadeIn();
    setTimeout(function(){
        hideLoader();
    }, 30000)
}

function hideLoader(){
    $(".js-loader").fadeOut();
}